<div id="principal" class="watermark">
  <div class="container-fluid px-lg-5">
    <div class="row">
      <div class="col-12">

        <h2 class="title">Principal’s Message</h2>

        <div class="row align-items-start mt-4">
          <!-- Left Column (Message Content) -->
          <div class="col-lg-8 col-md-12">

            <h3 class="welcome-title">Welcome to Shah Satnam ji Girls' College, Sirsa</h3>

            <p class="inner-lead"><strong>Warm greetings to all!</strong></p>

            <p class="inner-lead">
              Shah Satnam Ji Girls’ College is not merely an institution; it’s a vibrant tapestry woven with threads of academic excellence, holistic development and spiritual awakening. Here, we believe in nurturing young women who are not just intellectually sound, but also strong in a character, compassionate towards society and empowered to chase their dreams.
            </p>

            <p class="inner-lead">
              Here education extends beyond textbooks. We foster a love for learning through multitude of activities- from sports that ignite a spirit of healthy competition to cultural events that celebrate the richness of our heritage. Co-curricular activities provide a platform for students to discover hidden talents, develop leadership skills and become well- rounded individuals.
            </p>

            <p class="inner-lead">
              At the core of our philosophy lies an emphasis on spiritual and moral values i.e. <strong><em>Gurukul Sanskaras</em></strong> which is the dire need of the society,we draw inspiration from teachings of Saint Dr Gurmeet Ram Rahim Singh Ji Insan fostering a sense of compassion, integrity and service to humanity. This spiritual foundation equips our students to navigate the complexities of life with grace and purpose.
            </p>

            <p class="inner-lead">
              Our college boasts a history of outstanding achievements. Our students consistently excel in academics, sports and cultural activities bringing immense pride to our institution. But more importantly, we celebrate the success stories of young women who leave our portals, empowered to make a positive impact on the world.
            </p>

            <p class="inner-lead">
              If you are seeking an education that transcends boundaries, an environment that nurtures both mind and soul, then Shah Satnam Ji Girls’ College is your destination. We invite you to embark on a transformative journey of learning, growth and self-discovery.
            </p>

            <p class="inner-lead mb-4"><strong>Be the change you wish to see in the world.</strong></p>

            <!-- Signature block -->
            <div class="signature-block">
              <p class="inner-lead mb-1">With Warm Regards,</p>
              <p class="signature-title mb-1">Dr. Geeta Monga</p>
              <p class="signature-title mb-1">Principal</p>
              <p class="signature-title mb-0">Shah Satnam ji Girls' College,Sirsa</p>
            </div>

          </div>

          <!-- Right Column (Principal Photo with thick Navy frame) -->
          <div class="col-lg-4 col-md-12 text-center mt-4 mt-lg-0 d-flex justify-content-center justify-content-lg-end">
            <img src="/assets/img/message/principal.jpg" alt="Principal Dr. Geeta Monga" class="principal-photo-frame img-fluid">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
